import { render, staticRenderFns } from "./claim-card.vue?vue&type=template&id=88740eb0"
import script from "./claim-card.vue?vue&type=script&lang=js"
export * from "./claim-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports